// Auto-generated subset of themes/Images.js: only the images that api/lookingToMeetApi.js uses.
// Importing the full barrel would pull every PNG in the app into any bundle that touches this file.
/* eslint-disable global-require */
const images = {
  icWhoCouple: require('../../images/loginRegistration/icWhoCouple.png'),
  icWhoCoupleFF: require('../../images/loginRegistration/icWhoCoupleFF.png'),
  icWhoCoupleMM: require('../../images/loginRegistration/icWhoCoupleMM.png'),
  icWhoGroup: require('../../images/loginRegistration/icWhoGroup.png'),
  icWhoMen: require('../../images/loginRegistration/icWhoMen.png'),
  icWhoTVCD: require('../../images/loginRegistration/icWhoTVCD.png'),
  icWhoTransMan: require('../../images/loginRegistration/icWhoTransMan.png'),
  icWhoTransWoman: require('../../images/loginRegistration/icWhoTransWoman.png'),
  icWhoWoman: require('../../images/loginRegistration/icWhoWoman.png'),
};

export default images;
